import type { InboundReplyRow } from '../types';

export const OUTREACH_INBOX_MOCK: InboundReplyRow[] = [
  {
    id: 'r1',
    from_email: 'jfehnel@affiliate-arielgroup.com',
    from_name: 'Jay Fehnel',
    subject: 'Re: Engagements without hours logged',
    classification: 'reply',
    match_method: 'token',
    match_confidence: 1,
    status: 'parsed',
    stripped_text:
      'Hi Danielle - I did not meet in May with Jordan Blake and Riley Stone due to travel. I have met with them in June and updated coaching.com. Casey Lin and Drew Park have ongoing scheduling challenges.',
    received_at: new Date().toISOString(),
    created_at: new Date().toISOString(),
    delivery_mode: 'live',
    delivered_to_email: 'jfehnel@affiliate-arielgroup.com',
    intended_to_email: 'jfehnel@affiliate-arielgroup.com',
    parse: {
      id: '11111111-1111-4111-8111-111111111111',
      summary:
        'Two engagements were delayed by client travel but are now met and logged; two others have ongoing scheduling challenges already flagged to the team.',
      overall_sentiment: 'neutral',
      needs_human: false,
      confidence: 0.86,
      model: 'claude-opus-4-8',
      parsed_at: new Date().toISOString(),
      per_engagement: [
        { mentioned_coachee_names: ['Jordan Blake'], mentioned_client_names: ['Northwind'], categories: ['scheduling_delay_client_side', 'hours_just_logged'], delay_reason: 'client travel', promised_log_date: null, suggested_status_change: null, suppress_until: null, engagement_confidence: 0.9 },
        { mentioned_coachee_names: ['Riley Stone'], mentioned_client_names: ['Initech'], categories: ['scheduling_delay_client_side', 'hours_just_logged'], delay_reason: 'client travel', promised_log_date: null, suggested_status_change: null, suppress_until: null, engagement_confidence: 0.9 },
        { mentioned_coachee_names: ['Casey Lin'], mentioned_client_names: ['Umbrella'], categories: ['scheduling_delay_client_side'], delay_reason: 'ongoing scheduling challenge', promised_log_date: null, suggested_status_change: null, suppress_until: null, engagement_confidence: 0.75 },
        { mentioned_coachee_names: ['Drew Park'], mentioned_client_names: ['Umbrella'], categories: ['scheduling_delay_client_side'], delay_reason: 'ongoing scheduling challenge', promised_log_date: null, suggested_status_change: null, suppress_until: null, engagement_confidence: 0.75 },
      ],
    },
    ledger: [
      { id: 'l1', opportunity_id: 'o1', account_name: 'Northwind', coachee_name: 'Jordan Blake', category: 'scheduling_delay_client_side', categories: ['scheduling_delay_client_side', 'hours_just_logged'], body: 'client travel. Met in June and updated coaching.com.', promised_log_date: null, review_status: 'unverified', reviewed_by_email: null, reviewed_at: null, created_at: new Date().toISOString() },
      { id: 'l2', opportunity_id: 'o2', account_name: 'Initech', coachee_name: 'Riley Stone', category: 'scheduling_delay_client_side', categories: ['scheduling_delay_client_side', 'hours_just_logged'], body: 'client travel. Met in June and updated coaching.com.', promised_log_date: null, review_status: 'unverified', reviewed_by_email: null, reviewed_at: null, created_at: new Date().toISOString() },
      { id: 'l3', opportunity_id: 'o3', account_name: 'Umbrella', coachee_name: 'Casey Lin', category: 'scheduling_delay_client_side', categories: ['scheduling_delay_client_side'], body: 'ongoing scheduling challenge, already flagged to the team.', promised_log_date: null, review_status: 'unverified', reviewed_by_email: null, reviewed_at: null, created_at: new Date().toISOString() },
      { id: 'l4', opportunity_id: 'o4', account_name: 'Umbrella', coachee_name: 'Drew Park', category: 'scheduling_delay_client_side', categories: ['scheduling_delay_client_side'], body: 'ongoing scheduling challenge, already flagged to the team.', promised_log_date: null, review_status: 'unverified', reviewed_by_email: null, reviewed_at: null, created_at: new Date().toISOString() },
    ],
    review: null,
  },
  {
    id: 'r2',
    from_email: 'matt@kelm.ai',
    from_name: 'Matt Kelm',
    subject: 'Re: [TEST — intended for Bob Morris] an engagement awaiting its first logged session',
    classification: 'reply',
    match_method: 'token',
    match_confidence: 1,
    status: 'parsed',
    stripped_text: 'I completed the first session with Avery and logged the hours today.',
    received_at: new Date().toISOString(),
    created_at: new Date().toISOString(),
    delivery_mode: 'test',
    delivered_to_email: 'matt@kelm.ai',
    intended_to_email: 'bmorris@affiliate-arielgroup.com',
    parse: {
      id: '22222222-2222-4222-8222-222222222222',
      summary: 'The facilitator completed the first session and reports that the hours are now logged.',
      overall_sentiment: 'positive',
      needs_human: false,
      confidence: 0.94,
      model: 'claude-opus-4-8',
      parsed_at: new Date().toISOString(),
      per_engagement: [{
        mentioned_coachee_names: ['Avery'],
        mentioned_client_names: [],
        categories: ['hours_just_logged'],
        delay_reason: null,
        promised_log_date: null,
        suggested_status_change: null,
        suppress_until: null,
        engagement_confidence: 0.92,
        matched_opportunity_id: 'test-opp-1',
        matched_account_name: 'Example Client',
        matched_coachee_name: 'Avery',
        deterministic_match_confidence: 0.96,
        match_needs_human: false,
      }],
    },
    ledger: [],
    review: null,
  },
];
